
 var productSlider = new Swiper(".productSlider", {
    slidesPerView: 2.2,
    spaceBetween: 10,
    autoHeight: false,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
     // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 1.9
      },
      1280: {
        spaceBetween: 10,
        slidesPerView: 2.122
      }
    }
});

$(document).ready(function(){
    // Handle click event on accordion heading
    $('.shogun-accordion-heading').click(function(){
        // Toggle the plus/minus icon
        $(this).find('.shogun-accordion-icon').toggleClass('shogun-icon-plus shogun-icon-minus');
        // Toggle visibility of accordion body
        $(this).next('.shogun-accordion-body').slideToggle();
    });
});
